/** Central role normalization and authorization helpers. */
export function getUserRole(userOrRole) {
  if (typeof userOrRole === "string") return userOrRole.trim().toLowerCase();
  const raw =
    userOrRole?.userRole ??
    userOrRole?.UserRole ??
    userOrRole?.role ??
    userOrRole?.Role ??
    "";
  return String(raw).trim().toLowerCase();
}

export function isSuperAdmin(userOrRole) {
  return getUserRole(userOrRole).replace(/[\s_-]/g, "") === "superadmin";
}

export function isAdmin(userOrRole) {
  return getUserRole(userOrRole) === "admin";
}

/** Observer includes the two legacy values still returned for existing accounts. */
export function isObserver(userOrRole) {
  const role = getUserRole(userOrRole);
  return role === "observer" || role === "observator" || role === "user" || role === "auth";
}

export function getUserRoleBucket(userOrRole) {
  if (isSuperAdmin(userOrRole)) return "superadmin";
  if (isAdmin(userOrRole)) return "admin";
  if (isObserver(userOrRole)) return "observer";
  return "other";
}

export function roleCanManageUsers(userOrRole) {
  return isSuperAdmin(userOrRole) || isAdmin(userOrRole);
}

export function roleCanWrite(userOrRole) {
  return isSuperAdmin(userOrRole) || isAdmin(userOrRole);
}

export const OBSERVER_LANDING_ROUTE = "/dashboard";

export function getLandingRoute(userOrRole) {
  return isObserver(userOrRole) ? OBSERVER_LANDING_ROUTE : "/dashboard";
}

export const OBSERVER_ROUTE_KEYS = new Set([
  "dashboard",
  "statistiques",
  "tout-voir-establishment",
  "establishment-attendance",
]);

export function canAccessRoute(userOrRole, routeKey) {
  if (routeKey === "parametres") return isSuperAdmin(userOrRole);
  return !isObserver(userOrRole) || OBSERVER_ROUTE_KEYS.has(routeKey);
}
